import { render, staticRenderFns } from "./no-approval.vue?vue&type=template&id=19bfc120&scoped=true&"
import script from "./no-approval.vue?vue&type=script&lang=js&"
export * from "./no-approval.vue?vue&type=script&lang=js&"
import style0 from "./no-approval.vue?vue&type=style&index=0&id=19bfc120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfc120",
  null
  
)

export default component.exports